import { queryOptions } from '@tanstack/react-query'
import { listPreferences } from './api'

export const notificationPreferenceQueries = {
  all: () => ['notification-preferences'],
  list: () =>
    queryOptions({
      queryKey: notificationPreferenceQueries.all(),
      queryFn: () => listPreferences(),
    }),
}
